import { render } from "./DeleteRecordModelBox.vue?vue&type=template&id=52c62c84"
import script from "./DeleteRecordModelBox.vue?vue&type=script&lang=js"
export * from "./DeleteRecordModelBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__